import { ref } from 'vue';

export function useConfirmAction() {
  const state = ref({
    visible: false,
    action: null,
    appointment: null,
  });

  let resolver = null;

  const open = ({ action, appointment }) => {
    if (state.value.visible) {
      throw new Error('A confirmation is already open');
    }
    state.value = { visible: true, action, appointment };
    return new Promise(resolve => {
      resolver = resolve;
    });
  };

  const confirm = (note = null) => {
    if (!resolver) return;
    const fn = resolver;
    resolver = null;
    state.value = { visible: false, action: null, appointment: null };
    fn({ confirmed: true, note: note ? String(note) : null });
  };

  const cancel = () => {
    if (!resolver) return;
    const fn = resolver;
    resolver = null;
    state.value = { visible: false, action: null, appointment: null };
    fn({ confirmed: false, note: null });
  };

  return { state, open, confirm, cancel };
}
